<template>
  <div class="animate-route">
    <details-info :title="decorInfo.flowerTitle" scale :imgSrc="imgUrl + decorInfo.detailsImg"> </details-info>
  </div>
</template>
<script>
import DetailsInfo from '@/components/DetailsInfo'
import { getDecorById } from '@/api'
export default {
  components: {
    DetailsInfo,
  },
  data() {
    return {
      decorInfo: {},
      imgUrl: process.env.VUE_APP_IMG_URL,
    }
  },
  created() {
    const id = this.$route.query.id
    getDecorById({ id: id }).then((res) => {
      this.decorInfo = res.result
    })
  },
}
</script>
<style lang="stylus">
@import './index'
route()
</style>
